import Link from "next/link";
import { FC, useState } from "react";
import ArrowIcon from "@svg/footer/arrow";
import { IconChevronDown } from "@svg/chevron-down";
import classNames from "classnames";

interface Props {
  category: {
    title: string;
    moreItems: string;
    srcIcon: React.ReactNode;
    subCategories: {
      title: string;
      link: string;
    }[];
  };
}

const EachFooterCategory: FC<Props> = ({ category }) => {
  const [openAccordion, setOpenAccordion] = useState(false);

  return (
    <div className="w-full">
      <div
        className="flex w-full justify-between items-center sm:pointer-events-none sm:cursor-default cursor-pointer"
        onClick={() => setOpenAccordion((prev) => !prev)}
        role="button"
        aria-expanded={openAccordion}
      >
        <div className="flex gap-1">
          <div className="ml-1.5">{category.srcIcon}</div>
          <p className="font-semibold mb-3 text-sm sm:text-base text-fds-primary grow shrink-0">
            {" "}
            {category.title}
          </p>
        </div>
        <IconChevronDown
          className={classNames(
            "sm:hidden transition-transform",
            openAccordion ? "rotate-180" : "rotate-0"
          )}
        />
      </div>
      <div
        className={classNames(
          "flex flex-col gap-1 w-full overflow-hidden transition-height duration-500 sm:h-auto",
          openAccordion ? "h-44" : "h-0"
        )}
      >
        {category.subCategories.map((subCategory) => (
          <div key={subCategory.title}>
            <Link
              className="font-normal text-fds-primary  leading-7 text-xs sm:text-sm cursor-pointer"
              href={subCategory.link}
              prefetch={false}
            >
              {subCategory.title}
            </Link>
          </div>
        ))}
      </div>
      {category.moreItems ? (
        <div className="my-2 hidden sm:block">
          <Link
            href={category.moreItems}
            prefetch={false}
            className="flex items-center font-normal text-sm hover:text-fds-brand text-fds-secondary leading-7"
          >
            موارد بیشتر
            <ArrowIcon className="h-5 w-5 mr-1" />
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default EachFooterCategory;
